import { render, staticRenderFns } from "./pending-transfer-item-v2.vue?vue&type=template&id=fcb2846c&scoped=true"
import script from "./pending-transfer-item-v2.vue?vue&type=script&lang=js"
export * from "./pending-transfer-item-v2.vue?vue&type=script&lang=js"
import style0 from "./pending-transfer-item-v2.vue?vue&type=style&index=0&id=fcb2846c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb2846c",
  null
  
)

export default component.exports